<script>
import DatepickerComponent from './Datepicker.vue'
import DropdownComponent from './Dropdown.vue'
import store from '../store'
import { get as getAvailability } from '../services/availability'
import { getDateString, normalizeDate } from '../date'

export default {
    // state
    data () {
        return {
            // availability
            availability: null,
            isGettingAvailability: null,
            // date
            startDate: null,
            endDate: null,
            // property
            propertyRentalSourceId: null,
            // rate plan
            ratePlan: null,
            // room types
            roomType: null,
            roomTypeOptions: null,
            // user
            userId: null,
            points: null,
        }
    },
    props: {
        property: String,
        user: String,
    },
    computed: {
        roomTypeDropdown () {
            const isFullWidth = store.breakpoint.includes('s')
            return {
                from: 'right',
                isFullWidth,
                label: 'Room Type',
                labelIsHidden: isFullWidth,
                options: this.roomTypeOptions,
                value: this.roomType,
            }
        },
        slideCount () {
            return store.breakpoint.includes('s') ? 1 : 2
        },
        slideSize () {
            return store.breakpoint.includes('xs') ||
                store.breakpoint === 'md' ||
                    store.breakpoint === 'lg' ? 'base' : 'lg'
        },
    },
    methods: {
        setRoomType (roomType) {
            this.roomType = roomType
        },
        updateAvailability () {
            this.isGettingAvailability = true
            const params = {
                propertyRentalSourceId: this.propertyRentalSourceId,
                numberOfBedrooms: this.roomType,
                startDate: getDateString(this.startDate),
                endDate: getDateString(this.endDate),
            }
            if (typeof this.userId === 'number') {
                params.userId = this.userId
            }
            getAvailability({ params })
                .then(r => r.json())
                .then(json => {
                    this.availability = json.results
                    this.isGettingAvailability = false
                })
        },
    },
    watch: {
        roomType () {
            this.updateAvailability()
        },
    },
    // lifecycle
    created () {
        // dates
        this.startDate = normalizeDate(new Date)
        this.endDate = new Date(
            this.startDate.getUTCFullYear() + 1,
            this.startDate.getUTCMonth(),
            this.startDate.getUTCDate() - 1,
        )
        // property
        const { propertyRentalSourceId, roomTypes } = JSON.parse(this.property)
        this.propertyRentalSourceId = propertyRentalSourceId
        // room types
        this.roomTypeOptions = roomTypes.sort()
            .map(x => ({
                display: x > 0 ? `${x} Bedroom` : x < 0 ? 'Hotel Room' : 'Studio',
                value: x,
            }))
        this.roomTypeOptions.push({ display: 'All', value: null })
        this.roomType = null
        // user
        Object.assign(this, JSON.parse(this.user))
        // rate plan
        this.ratePlan = this.points ? 'points' : 'usd'
        // availability
        this.updateAvailability()
    },
    // misc.
    components: {
        Datepicker: DatepickerComponent,
        Dropdown: DropdownComponent,
    },
}
</script>

<template>
    <div
        class="
            tw-mx-auto
            tw-w-fit
        "
    >
        <Datepicker
            class="tw-relative tw-z-0 tw-mt-6"
            v-bind="{
                isSelectable: false,
                // availability
                availability,
                hasAvailabilityData: !!availability,
                isGettingAvailability,
                // dates
                startDate,
                endDate,
                // rate plan
                ratePlan,
                // slides
                slideCount,
                slideSize
            }"
        >
            <template v-slot:header>
                <Dropdown
                    class="
                        tw-ml-0
                        tw-w-full
                        sm:tw-w-auto
                    "
                    v-bind="roomTypeDropdown"
                    v-on:select="setRoomType($event.detail.value)"
                />
            </template>
        </Datepicker>
    </div>
</template>
